export default {"src":"/_next/static/media/zksync-era-explorer.b4fb2676.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};